module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.selectedStation.show) ? _c('div', [_c('div', {
    staticClass: "offcanvas-wrapper"
  }, [_c('div', {
    staticClass: "offcanvas-sidebar container-fluid"
  }, [_c('div', {
    staticClass: "row align-items-center",
    staticStyle: {
      "height": "100%"
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-107867b7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./Resources/Private/JavaScript/components/gasStationFinder/stationDetail.vue
// module id = 105
// module chunks = 0